export const environment = {
  production: false,
  authUrl: 'https://hallmonitor-test.auth.eu-central-1.amazoncognito.com',
  apiUrl: 'https://dev-frontend.hallmonitor.eu',
  clientId: '4c9n39jk4ktf555vif2c3go2ud',
};
